import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const user = await login(email, password);
      if (user.role !== "admin") {
        setError("Akaun ini bukan admin.");
        return;
      }
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-4 py-24 sm:px-8">
      <span className="grid h-11 w-11 place-items-center rounded-md bg-slate-900 text-white">
        <ShieldCheck className="h-5 w-5" />
      </span>
      <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight">Admin Login</h1>
      <p className="mt-2 text-sm text-slate-600">Urus paywall RM5 dan kelulusan senarai.</p>

      <form onSubmit={submit} className="mt-8 grid gap-5 rounded-lg border border-border bg-card p-6 shadow-sm">
        <div>
          <Label htmlFor="email">Emel</Label>
          <Input id="email" type="email" data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11" />
        </div>
        <div>
          <Label htmlFor="password">Kata Laluan</Label>
          <Input id="password" type="password" data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11" />
        </div>
        {error && (
          <p data-testid="admin-login-error" className="text-sm font-medium text-destructive">
            {error}
          </p>
        )}
        <Button type="submit" data-testid="admin-login-button" disabled={busy} className="h-11 bg-primary hover:bg-[#0052CC]">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Masuk
        </Button>
      </form>
    </div>
  );
}
